export default "__VITE_PUBLIC_ASSET__41ee443a__"